import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'umi';
import { Badge, Space, Tag } from 'antd';
import isEmpty from 'lodash/isEmpty';
import LeadDropdownFilter, { ILeadDropdownFilterProps } from '@/components/Filters/LeadDropdownFilter';
import { F } from '@/utils/intl';
import styles from './index.less';
import { LeadStateModel } from '@/typings/models/LeadState';
import * as LeadStateSelectors from '@/selectors/leadStateSelectors';


export const LeadStatePresentation = ({state, className}: { state: LeadStateModel, className?: string }) => <Space className={className}>
  <Tag rootClassName={styles.leadStateTag} style={{color: "#fff !important"}} variant={"solid"} color={state.color}>{state.label}</Tag>
</Space>


export const LeadStateDotPresentation = ({state, className}: { state: LeadStateModel, className?: string }) => <Space className={className}>
  <Badge color={state.color}/>
  <span>{state.label}</span>
</Space>
export const LeadStateTagPresentation = ({ state }: { state: LeadStateModel }) =>
  isEmpty(state) ? null : (
    <Tag
      rootClassName={styles.leadStateTag}
      variant={'solid'}
      style={{ color: '#fff' }}
      color={state.color}
    >
      {state.label}
    </Tag>
  );

const LeadStateDropdownFilter = (props: Partial<ILeadDropdownFilterProps> = { }) => {
  const dispatch = useDispatch()
  const leadStates = useSelector(LeadStateSelectors.selectStates)
  const optionRender = (state: LeadStateModel) => <LeadStatePresentation state={state}/>

  useEffect(() => {
    if (isEmpty(leadStates)) {
      dispatch({
        type: 'leadStates/fetch'
      })
    }
  }, []);

  return (
    <LeadDropdownFilter
      type={props?.type ? props.type : 'tree'}
      optionRender={optionRender}
      placeholder={
        <F
          id={'common.attribute.status'}
          defaultMessage={'Status'}
        />
      }
      filterKey={'lead_state'}
      treeData={leadStates?.map((state) => ({
        ...state,
        title: state.label,
        value: state.id,
        key: state.id,
      }))}
      options={leadStates}
      {...props}
    />
  );
}

export default LeadStateDropdownFilter
